import { enMenu } from "./menusLang/enMenu";
import { seMenu } from "./menusLang/seMenu";
import { deMenu } from "./menusLang/deMenu";
import { uaMenu } from "./menusLang/uaMenu";
import { ruMenu } from "./menusLang/ruMenu";
import { elMenu } from "./menusLang/elMenu";
export const menuItems = {
  menu: [
    {
      langKey: "en",
      items: enMenu,
    },
    {
      langKey: "se",
      items: seMenu,
    },
    {
      langKey: "de",
      items: deMenu,
    },
    {
      langKey: "ua",
      items: uaMenu,
    },
    {
      langKey: "ru",
      items: ruMenu,
    },
    {
      langKey: "el",
      items: elMenu,
    },
  ],
};

export function generateCategories(menu) {
  // Initialize an empty array to store categories
  let categories = [];
  const langKeys = extractLangKeys(menu);

  // Iterate over menu items for the first language
  menu[0].items.forEach((menuItem) => {
    const { category } = menuItem;

    // Check if category already exists in categories
    let existingCategory = categories.find(
      (el) => el.name && el.name[0] === category
    );

    // If not, add a new category entry to the array
    if (!existingCategory) {
      categories.push({ name: [category], ids: [menuItem.id] });
    } else existingCategory.ids.push(menuItem.id);
  });

  // Handle subcategories forthe 1st langusage
  menu[0].items.forEach((menuItem) => {
    const subCategory = menuItem?.subCategory || null;
    if (subCategory) {
      // Check if subcategory already exists in categories
      let existingSubCategory = categories.find(
        (el) => el.subName && el.subName[0] === subCategory
      );

      // If not, add a new subcategory entry to the array
      if (!existingSubCategory) {
        categories.push({ subName: [subCategory], ids: [menuItem.id] });
      } else existingSubCategory.ids.push(menuItem.id);
    }
  });

  const indexes = Array.from({ length: langKeys.length }, (_, index) => index);

  // Iterate over all languages and merge subcategories based on ids

  indexes.forEach((index) => {
    menu[index].items.forEach((item) => {
      categories.forEach((cat) => {
        if (cat.name && cat.ids.includes(item.id)) {
          if (!cat.name.includes(item.category)) {
            cat.name.push(item.category);
          }
        }
        // Check for subcategories
        if (cat.subName) {
          // Check if the item's id is in the subcategory's ids
          if (cat.ids.includes(item.id)) {
            // Check if the item's subCategory is not already in the subcategory's name array
            if (!cat.subName.includes(item.subCategory)) {
              cat.subName.push(item.subCategory); // Add the subcategory to the subName array
            }
          }
        }
      });
    });
  });

  // Create a result object with unique category and subcategory values
  let result = {};
  categories.forEach((el, i) => {
    if (el.name) {
      result[i + 1] = el.name;
    }
    if (el.subName) {
      result[i + 100] = el.subName;
    }
  });

  return result;
}

export const getLangMenu = (menu, lang = "en") => {
  let menuLang = menu.find((item) => item.langKey === lang);
  if (!menuLang) {
    return menu.find((item) => item.langKey === "en").items;
  }
  return menuLang.items;
};

function extractLangKeys(menu) {
  // Initialize an empty array to store langKeys
  const langKeys = [];

  // Iterate over each object in the menu array
  menu.forEach((langObject) => {
    // Extract langKey from the current object and push it to langKeys array
    langKeys.push(langObject.langKey);
  });

  // Return the array of langKeys
  return langKeys;
}

export function getCategoryId(categoryStr, categories) {
  // Find ID associated with this category in any language
  // console.log("111", categoryStr);
  for (const categoryId in categories) {
    if (categories[categoryId].includes(categoryStr)) {
      return categoryId;
    }
  }
}
export const getUniqueCategories = (
  menu,
  lang,
  categories,
  onlyMenuFromParams,
  filteredMenuItems = null
) => {
  let items;
  // eslint-disable-next-line

  // if (onlyMenuFromParams == 1 || onlyMenuFromParams == 2) {
  //   console.log("MENU ITEMS = ", filteredMenuItems);
  //   items = filteredMenuItems;
  // } else {
  const menuInLang =
    menu.find((item) => item.langKey === lang) ||
    menu.find((item) => item.langKey === "en");

  items = menuInLang.items;
  // }

  const categoriesSet = new Set(items.map((menuItem) => menuItem.category));

  // Convert Set back to an array
  const uniqueCategories = [...categoriesSet];

  const uniqueCategorieswithIds = uniqueCategories.map((cur) => {
    const id = getCategoryId(cur, categories);
    return { [id]: cur };
  });

  return { cat: uniqueCategories, ids: uniqueCategorieswithIds };
};

export const menuWithIds = (menu, categories) => {
  const updatedMenu = [];

  for (const { langKey, items } of menu) {
    const updatedItems = items.map((item) => {
      const categoryId = getCategoryId(item.category, categories);
      const plainItem = item;
      return {
        ...plainItem,
        category_id: categoryId,
      };
    });

    updatedMenu.push({ langKey, items: updatedItems });
  }

  return updatedMenu;
};

export function getSubcategories(
  menu,
  categories,
  categoryId,
  lang,
  menuOnly = null
) {
  const menuLang = getLangMenu(menu, lang);

  let filteredItems = menuLang.filter(
    (item) => item.category_id === categoryId
  );
  // eslint-disable-next-line
  if (menuOnly == 1) {
    filteredItems = filteredItems.filter(
      (item) => item.restaurantMenu === true
    );
  }
  // eslint-disable-next-line
  if (menuOnly == 2) {
    filteredItems = filteredItems.filter((item) => item.beachMenu === true);
  }

  const subCategoriesArray = filteredItems.reduce((acc, cur) => {
    const subCategory = cur?.subCategory || "others";
    if (!acc.includes(subCategory)) {
      acc.push(subCategory);
    }
    return acc;
  }, []);

  // Transform subCategoriesArray into an array of objects
  const subCategoriesObjectsArray = subCategoriesArray.map((subcategory) => {
    const id = getCategoryId(subcategory, categories);
    return { [id]: subcategory };
  });

  return { name: subCategoriesArray, ids: subCategoriesObjectsArray };
}

//WORKING WELL
export const filterMenuItemsId = (
  menu,
  categoryId,
  lang,
  sub = null,
  onlyMenuFromParams = null
) => {
  const menuLang = getLangMenu(menu, lang);
  const menuEn = getLangMenu(menu, "en");

  let filteredItems = menuLang.filter((item) => {
    if (categoryId === "*") return true;
    return item.category_id === categoryId;
  });

  if ((onlyMenuFromParams == 1 || !onlyMenuFromParams) && lang === "en") {
    filteredItems = filteredItems.filter(
      (item) => item.restaurantMenu === true
    );
  }
  if (onlyMenuFromParams == 2 && lang === "en") {
    filteredItems = filteredItems.filter((item) => item.beachMenu === true);
  }

  if (onlyMenuFromParams == 1 && lang !== "en") {
    const arrayToReturn = filteredItems.filter((item) => {
      const enItem = menuEn.find(
        (enItem) => enItem.menuNumber === item.menuNumber
      );
      return item;
    });

    filteredItems = arrayToReturn;
  }

  if (onlyMenuFromParams == 2 && lang !== "en") {
    filteredItems = filteredItems.filter((item) => {
      const enItem = menuEn.find((enItem) => enItem.id === item.id);
      return enItem && enItem.beachMenu === true;
    });
  }

  console.log("sub from suspiciooyus", sub);
  if (sub === null) {
    return filteredItems;
  } else if (sub === "others") {
    return filteredItems.filter((item) => !item.subCategory);
  } else if (typeof sub === "string") {
    return filteredItems.filter((item) => item.subCategory === sub);
  }

  return filteredItems;
};

export const categories = generateCategories(menuItems.menu);

export const menuUpd = menuWithIds(menuItems.menu, categories);

export const isRestItem = (id) => {
  const enMenu = menuUpd.find(({ langKey }) => langKey === "en");
  if (Array.isArray(enMenu.items)) {
    const item = enMenu.items.find((item) => item.id === id);
    if (item && item.restaurantMenu === true) {
      return true;
    }
  }
  return false;
};

export const isBeachItem = (id) => {
  const enMenu = menuUpd.find(({ langKey }) => langKey === "en");
  if (Array.isArray(enMenu.items)) {
    const item = enMenu.items.find((item) => item.id === id);
    if (item && item.beachMenu === true) {
      return true;
    }
  }
  return false;
};

export const hasBeachMenuItemsInCategory = (categoryId) => {
  const enMenu = menuUpd.find(({ langKey }) => langKey === "en");
  //   const category = enMenu.items.find((cat) => cat.category_id === categoryId);
  //   console.log(category);

  return enMenu.items.some(
    (item) => item.beachMenu === true && item.category_id === categoryId
  );
};

export const hasRestMenuItemsInCategory = (categoryId) => {
  const enMenu = menuUpd.find(({ langKey }) => langKey === "en");
  //   const category = enMenu.items.find((cat) => cat.category_id === categoryId);
  //   console.log(category);

  return enMenu.items.some(
    (item) => item.restaurantMenu === true && item.category_id === categoryId
  );
};

// export const getfilteredCategories = (filteredItemsId) => {
//   // Initialize an empty object to store the categories
//   let objtoReturn = {};

//   // Iterate over the filtered items
//   filteredItemsId.forEach((item) => {
//     // Iterate over the categories
//     Object.entries(categories).forEach(([categoryId, categoryName]) => {
//       // Check if the item's category_id matches the current categoryId
//       if (item.category_id === parseInt(categoryId, 10)) {
//         // Add the category to objtoReturn if not already present
//         if (!objtoReturn[categoryId]) {
//           objtoReturn[categoryId] = categoryName;
//         }
//       }
//     });
//   });

//   // Convert objtoReturn to the required format
//   const filteredCategories = Object.keys(objtoReturn).map((key) => ({
//     [key]: objtoReturn[key],
//   }));

//   // Return the array of category IDs and names
//   return filteredCategories;
// };
